/*
 * LoginPage
 *
 * Login user
 */
import React, { useEffect, useState } from 'react';
import { ApiRequest } from '../../../helpers';
import { PaymentRequestButtonElement, useStripe } from '@stripe/react-stripe-js';

const CheckoutForm = ({ client, cartPricing, checkoutStripePayment, stripeRequestPayment, setIsPaymentEnabled, hasQuestionNotAnswered }) => {
	let stripe = useStripe();
	const [paymentRequest, setPaymentRequest] = useState(null);
	const [total, setTotal] = useState(0);

	const disableButton = (e) => {
		e.preventDefault();
		return false;
	}

	useEffect(() => {
		let pr;
		if (stripe) {
			if (cartPricing.txn_gross) {
				pr = stripe.paymentRequest({
					country: client.billing_country,
					currency: client.billing_country === 'CA' ? 'cad' : 'usd',
					total: {
						label: 'Showtix4U',
						amount: Math.round(cartPricing.txn_gross*100),
					},
					requestPayerName: true,
					requestPayerEmail: true,
				}).on('paymentmethod', ({ complete, paymentMethod, ...data }) => {
					console.log("[PaymentMethod]", paymentMethod);
					console.log("[Customer Data]", data);
					complete("success");
				});

				if (cartPricing.txn_gross !== total) {
					console.log('update pricing')
					pr = null;
					setPaymentRequest(pr);
					pr = stripe.paymentRequest({
						country: client.billing_country,
						currency: client.billing_country === 'CA' ? 'cad' : 'usd',
						total: {
							label: 'Showtix4U',
							amount: Math.round(cartPricing.txn_gross*100),
						},
						requestPayerName: true,
						requestPayerEmail: true,
					}).on('paymentmethod', ({ complete, paymentMethod, ...data }) => {
						console.log("[PaymentMethod]", paymentMethod);
						console.log("[Customer Data]", data);
						complete("success");
					});
				}
				setTotal(cartPricing.txn_gross);
			}

			// Check the availability of the Payment Request API.
			if (pr) {
				pr.canMakePayment().then(result => {
					console.log('result', result)
					if (result) {
						setPaymentRequest(pr);
						setIsPaymentEnabled(true);
						if (!result.applePay && !result.googlePay) {
							setIsPaymentEnabled(false);
						}
					} else {
						setIsPaymentEnabled(false);
					}
				});
				pr.on('paymentmethod', ({ complete, paymentMethod, ...data }) => {
					console.log('paymentmethod complete', complete)
					console.log('paymentmethod paymentMethod', paymentMethod)
					console.log('paymentmethod data', data)
					if (stripeRequestPayment === 'fail') {
						complete('fail');
					}
					if (stripeRequestPayment === 'success') {
						complete('success');
					}
					checkoutStripePayment(pr, stripe, paymentMethod, data, complete);
				});
			}
		}
	}, [stripe, stripeRequestPayment, cartPricing]);

	if (paymentRequest && !hasQuestionNotAnswered) {
		return <PaymentRequestButtonElement options={{paymentRequest}} />
	}

	if (paymentRequest && hasQuestionNotAnswered) {
		return (
			<span className="stripe-is-disabled">
				<PaymentRequestButtonElement options={{paymentRequest}} onClick={(e) => disableButton(e)} />
			</span>
		);
	}

	// Use a traditional checkout form.
	return false;
}

export default CheckoutForm;




// WEBPACK FOOTER //
// ./src/components/Common/StripePayment/CheckoutForm.js